import {Component, input} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AddressFormModel } from './address-form.model';
import { TranslatePipe } from '@ngx-translate/core';
import { TextInput } from '../../../../components/text-input/text-input';
import { CountryDropdown } from '../../../../components/country-dropdown/country-dropdown';

@Component({
  selector: 'elcia-address-form',
  imports: [
    TextInput,
    TranslatePipe,
    ReactiveFormsModule,
    CountryDropdown
  ],
  templateUrl: './address-form.html',
  styleUrl: './address-form.scss',
})

export class AddressForm {
  control = input.required<FormGroup<AddressFormModel>>();
}
